export const CORPORATE_STRUCTURE = [
    'Non-Profit Organization',
    'Individual/sole proprietor or Single-member LLC',
    'C Corporation',
    'S Corporation',
    'Partnership',
    'Trust/estate',
    'Professional Corporation',
];
export const CORPORATE_STRUCTURE_OPTIONS = CORPORATE_STRUCTURE.map((structure) => ({
    label: structure,
    value: structure,
}));
//# sourceMappingURL=corporateStructure.js.map